import { IUnBlockUser } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { UN_BLOCK } from "../../routes";

const unBlock = async (props: IUnBlockUser) => {
  const body = {
    data: {
      blockId: props.blockId,
      id: props.userId,
    },
  };
  try {
    return (await customAxios.delete(UN_BLOCK, body)).data;
  } catch (error: any) {
    console.log({ DELETE_COMPANY: error });
    return false;
  }
};

export default unBlock;
